import { WEB_COMPONENT_IN_PRODUCT_TRIALS_OVERLAY_WINDOWS_APP } from '../../../../webcomponents.constants';
import { InProductTrialsOverlayWindowsAppWebComponent } from './component/InProductTrialsOverlayWindowsAppWebComponent';

export { InProductTrialsOverlayWindowsAppWebComponent };

window.customElements.define(
  WEB_COMPONENT_IN_PRODUCT_TRIALS_OVERLAY_WINDOWS_APP,
  InProductTrialsOverlayWindowsAppWebComponent
);
